/**
 * Class to format price, in logic comparable to \App\Utils\PriceFormatter
 */

export interface VendorPriceFormat {
  currencySymbol: string;
  decimalSeparator: string;
  thousandsSeparator: string;
  zeroDecimalsReplacement?: string;
  appendAsterisk?: boolean;
  currencySymbolAppended?: boolean;
  dropZeroDecimals?: boolean;
  currencySymbolNoSpacing?: boolean;
}

export class PriceFormatHelper {
  format: VendorPriceFormat;
  constructor(vendorPriceFormat: string) {
    this.format = JSON.parse(vendorPriceFormat);
  }

  /**
   * Returns a localized version of a price, with symbol and punctuation
   * @param price
   * @param discountedFraction
   */
  formatPrice(price: any, discountedFraction: any = 0) {
    if (!price) {
      return;
    }

    price = parseFloat(price);

    if (discountedFraction) {
      discountedFraction = parseFloat(discountedFraction);

      if (discountedFraction > 0) {
        discountedFraction = discountedFraction < 1 ? discountedFraction : 1 - discountedFraction / 100;
        price = price * discountedFraction;
      }
    }

    price = this.number_format(price, 2, this.format.decimalSeparator, this.format.thousandsSeparator);

    if (this.format.zeroDecimalsReplacement) {
      const priceParts = price.split(this.format.decimalSeparator);

      if (priceParts[1] === '00') {
        price = priceParts[0] + this.format.decimalSeparator + this.format.zeroDecimalsReplacement;
      }
    } else if (this.format.dropZeroDecimals) {
      const priceParts = price.split(this.format.decimalSeparator);

      if (priceParts[1] === '00') {
        price = priceParts[0];
      }
    }

    var space = this.format.currencySymbolNoSpacing ? '' : ' ';
    if (this.format.currencySymbolAppended) {
      return price + space + this.format.currencySymbol + (this.format.appendAsterisk ? '*' : '');
    } else {
      return this.format.currencySymbol + space + price + (this.format.appendAsterisk ? '*' : '');
    }
  }

  /**
   * Format number based on passed arguments
   *
   * @param number
   * @param decimals
   * @param dec_point
   * @param thousands_point
   * @returns {string|*}
   */
  number_format(number: any, decimals: any, dec_point: any, thousands_point: any): any {
    if (!decimals) {
      const len = number.toString().split('.').length;
      decimals = len > 1 ? len : 0;
    }

    if (!dec_point) {
      dec_point = '.';
    }

    if (!thousands_point) {
      thousands_point = ',';
    }

    // Round half down so that 10.995 becomes 10.99 not 11
    // We can do it by rounding a negative result:
    // Math.round(0.5)=1 but -Math.round(-0.5)=0
    number = -Math.round(-(parseFloat(number) * 100).toFixed(2)) / 100;
    number = number.toFixed(decimals);

    number = number.replace('.', dec_point);

    const splitNum = number.split(dec_point);
    splitNum[0] = splitNum[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands_point);
    number = splitNum.join(dec_point);

    return number;
  }
}

export { PriceFormatHelper as default };
